import React from "react";
import { connect } from "react-redux";

import TitleResultReport from "./TitleResultReport";
import TitleResultReportDefault from "./TitleResultReportDefault";

import AtleteDetailsContainer from "../reports/atleteDetail/AtleteDetailContainer";

import { ControlesAtleta } from "./reportsLogic";
import { DescargarCertificadoReg } from "./atleteDetail/certificadoLogic";

import FormDialog from "../Modals/FormDialog";

import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import SimpleDialogDemo from "../../OrganizerWeb/LayoutContainers/SimpleDialog";
import DNFAndDQView from "./DNFAndDQView";

class RowResultReportView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  descargarCertificadoReg = (
    e,
    eventDetail,
    resultadoJSON,
    tipo,
    certificateConfig
  ) => {
    e.preventDefault();
    DescargarCertificadoReg(
      eventDetail,
      resultadoJSON,
      tipo,
      certificateConfig
    );
  };

  render() {
    let resultado;
    let element;

    const compactCellStyle = {
      padding: "4px 6px",
      fontSize: "12px",
      lineHeight: "1.1",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
    };

    const compactCenteredCellStyle = {
      ...compactCellStyle,
      textAlign: "center",
    };

    const nameCellStyle = {
      padding: "4px 8px",
      fontSize: "12px",
      lineHeight: "1.1",
      verticalAlign: "middle",
      minWidth: 260,
      width: 320,
      maxWidth: 380,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    };

    const actionCellStyle = {
      ...compactCellStyle,
      minWidth: 90,
    };

    const compactRowStyle = {
      height: "30px",
    };

    const compactButtonStyle = {
      padding: "2px 4px",
      fontSize: "12px",
      lineHeight: "1.1",
      minHeight: "unset",
      textTransform: "none",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
      display: "inline-block",
    };

    const linkStyle = {
      marginRight: 8,
      fontSize: "11px",
      cursor: "pointer",
      display: "inline-block",
    };

    const typeRow = this.props.data.typeRow;

    if (typeRow === 1) {
      element = (
        <TitleResultReport
          data={this.props.data}
          controles={this.props.controles}
          controlesArray={this.props.controlesArray}
        />
      );
    } else if (typeRow === 3) {
      element = (
        <TitleResultReportDefault
          data={this.props.data}
          controles={this.props.controles}
          controlesArray={this.props.controlesArray}
        />
      );
    } else {
      function setStatus(resultadoFunc, eventConfigurationFunc) {
        resultadoFunc.text = "";
        resultadoFunc.button = "";

        if (
          resultadoFunc.nombre.indexOf("*") > 0 &&
          eventConfigurationFunc &&
          eventConfigurationFunc.timingConfig &&
          eventConfigurationFunc.timingConfig.showAll
        ) {
          resultadoFunc.pG = 0;
          resultadoFunc.pR = 0;
          resultadoFunc.pCat = 0;
          resultadoFunc.dnfPlus = true;
        }

        if (resultadoFunc.borrado) {
          resultadoFunc.dq = true;
        }

        if (!resultadoFunc.borrado && resultadoFunc.pG === 0) {
          resultadoFunc.dnf = true;
        }

        if (
          !resultadoFunc.registroSalida &&
          !resultadoFunc.parciales &&
          resultadoFunc.pG === 0 &&
          eventConfigurationFunc &&
          eventConfigurationFunc.timingConfig &&
          eventConfigurationFunc.timingConfig.showDNS
        ) {
          resultadoFunc.dns = true;
        }

        if (resultadoFunc.dnfPlus && !resultadoFunc.dns) {
          resultadoFunc.text =
            "El atleta no finalizó el evento en el tiempo previsto para la distancia";
          resultadoFunc.button = "DNF";
        } else if (resultadoFunc.dnf && !resultadoFunc.dns) {
          resultadoFunc.text = "El atleta no finalizó el evento";
          resultadoFunc.button = "DNF";
        } else if (resultadoFunc.dq) {
          resultadoFunc.text =
            "El atleta fué descalificado por los jueces del evento";
          resultadoFunc.button = "DQ";
        } else if (resultadoFunc.dns && !resultadoFunc.dq) {
          resultadoFunc.text = "El atleta no inició el evento";
          resultadoFunc.button = "DNS";
        }

        return resultadoFunc;
      }

      resultado = {
        ...this.props.data.result,
        ...setStatus(this.props.data.result, this.props.eventConfiguration),
      };

      const eventDetail = this.props.eventDetail;

      let controlesAtleta = [];
      let controlesTD = null;

      if (this.props.controles) {
        controlesAtleta = ControlesAtleta(
          this.props.puntosControl,
          resultado,
          this.props.controlesArray
        );

        controlesTD = controlesAtleta.map((control, index) => (
          <TableCell key={index} className={control.class} style={compactCenteredCellStyle}>
            {control.value}
          </TableCell>
        ));
      }

      const posiciones = [];
      if (resultado.pG === 0) {
        posiciones.push(
          <TableCell key="status" colSpan={3} style={compactCenteredCellStyle}>
            <SimpleDialogDemo fullScreen={false} buttonText={resultado.button}>
              <DNFAndDQView text={resultado.text} />
            </SimpleDialogDemo>
          </TableCell>
        );
      } else {
        // En filas de subclasificación (resultado.pSub !== undefined) se
        // muestra la posición en esa subclasificación en el mismo lugar que
        // "Lugar Categoría" en vez de agregar una columna más — así la
        // tabla tiene siempre la misma cantidad de columnas en todas las
        // secciones, se mezclen o no filas normales y de subclasificación.
        const posicionCategoria = resultado.pSub !== undefined ? resultado.pSub : resultado.pCat;
        posiciones.push(
          <TableCell key="pg" style={compactCenteredCellStyle}>
            {resultado.pG}
          </TableCell>
        );
        posiciones.push(
          <TableCell key="pr" style={compactCenteredCellStyle}>
            {resultado.pR}
          </TableCell>
        );
        posiciones.push(
          <TableCell key="pcat" style={compactCenteredCellStyle}>
            {posicionCategoria}
          </TableCell>
        );
      }

      const certificateConfig =
        this.props.eventConfiguration &&
          this.props.eventConfiguration.timingConfig &&
          this.props.eventConfiguration.timingConfig.certificateConfig
          ? this.props.eventConfiguration.timingConfig.certificateConfig
          : false;

      element = (
        <TableRow style={compactRowStyle}>
          <TableCell style={compactCenteredCellStyle}>{resultado.num}</TableCell>

          {posiciones}

          <TableCell component="th" scope="row" style={nameCellStyle}>
            <FormDialog
              buttomLabel={resultado.nombre}
              ShowIcon={false}
              ButtonStyle={compactButtonStyle}
              maxWidthProp={"lg"}
              style={{
                minHeight: "80vh",
                maxHeight: "80vh",
              }}
              report={
                <AtleteDetailsContainer
                  eventDetail={this.props.eventDetail}
                  resultado={resultado}
                />
              }
            />
          </TableCell>

          <TableCell style={compactCenteredCellStyle}>{resultado.gen}</TableCell>
          <TableCell style={compactCenteredCellStyle}>{resultado.cat}</TableCell>
          <TableCell style={compactCenteredCellStyle}>{resultado.mod}</TableCell>

          {controlesTD}

          <TableCell style={compactCenteredCellStyle}>{resultado.toMS || resultado.to}</TableCell>
          <TableCell style={compactCenteredCellStyle}>{resultado.tcMS || resultado.tc}</TableCell>

          {resultado.pG > 0 && !resultado.borrado ? (
            <TableCell style={actionCellStyle}>
              <a
                onClick={(e) =>
                  this.descargarCertificadoReg(
                    e,
                    eventDetail,
                    resultado,
                    2,
                    certificateConfig
                  )
                }
                className="waves-effect waves-teal btn-flat"
                target="_blank"
                rel="noopener noreferrer"
                style={linkStyle}
              >
                JPG
              </a>

              <a
                onClick={(e) =>
                  this.descargarCertificadoReg(
                    e,
                    eventDetail,
                    resultado,
                    1,
                    certificateConfig
                  )
                }
                className="waves-effect waves-teal btn-flat"
                target="_blank"
                rel="noopener noreferrer"
                style={linkStyle}
              >
                PDF
              </a>
            </TableCell>
          ) : (
            <TableCell style={actionCellStyle} />
          )}
        </TableRow>
      );
    }

    return element;
  }
}

const mapDispatchToProps = () => {
  return {};
};

const mapStateToProps = (state) => {
  return {
    eventDetail: state.events.eventDetail,
    eventConfiguration: state.events.eventConfiguration,
    puntosControl: state.events.puntosControl,
  };
};

const RowResultReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(RowResultReportView);

export default RowResultReport;